import { useState } from "react";

import { useTranslation } from "../../i18n";

import type { IdentifyFeatureItem } from "./types";

export function IdentifyFeature({
  item,
  onZoomToFeature,
}: {
  item: IdentifyFeatureItem;
  onZoomToFeature: (item: IdentifyFeatureItem) => Promise<void>;
}) {
  const { t } = useTranslation();
  const [zooming, setZooming] = useState(false);
  const fields = Object.entries(item.fields || {})
    .filter(
      ([, value]) => value !== null && value !== undefined && value !== "",
    )
    .slice(0, 6);

  return (
    <article className="identify-item">
      <button
        type="button"
        className="identify-title"
        disabled={zooming}
        onClick={async (event) => {
          event.preventDefault();
          event.stopPropagation();

          if (zooming) return;
          setZooming(true);
          try {
            await onZoomToFeature(item);
          } finally {
            setZooming(false);
          }
        }}
      >
        <span>{item.label || t("common.feature", { id: item.id })}</span>
        <small>{item.layerId}</small>
      </button>
      {!!fields.length && (
        <dl>
          {fields.map(([key, value]) => (
            <div className="identify-field" key={key}>
              <dt>{key}</dt>
              <dd>{String(value)}</dd>
            </div>
          ))}
        </dl>
      )}
    </article>
  );
}
